var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex"},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.size,"value":_vm.progressValue,"width":_vm.width}},[_vm._v(" "+_vm._s(_vm.formattedTimeLeft)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }